<template>
<div id ="tags">
  <h2>Tags</h2>

  <tag-nav></tag-nav>

  <pagination
    :pageSize="$root.defaultPageSize"
    :resourceUrl="this.apiUrl('/tags', true)"
    orderBy="slug"
    orderType="DESC"
    ref="pagination"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'tag', params: { tagId: item.id }}"
      >
        {{ item.name }}
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import TagNav from '@/components/TagNav'

export default {
  components: {
    'tag-nav': TagNav,
    'pagination': Pagination
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tags.vue